import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppIconComponent } from '../../../../../../../common/components/icon/icon.component';
import { FormInputDirective } from '../../../../../../../common/directives/form-input.directive';
import { Gender } from '../../../../../../../core/data/enums/gender.enum';
import { InsuranceTypeDto } from '../../../../../../../core/data/dtos/insurance-type.dto';
import { OccupationDto } from '../../../../../../../core/data/dtos/occupation.dto';
import { DatepickerInputComponent } from '../../../../../../../common/components/datepicker-input/datepicker-input.component';

@Component({
  selector: 'app-primary-insured',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppIconComponent,
    FormInputDirective,
    DatepickerInputComponent,
  ],
  templateUrl: './primary-insured.component.html',
})
export class PrimaryInsuredComponent {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) option!: InsuranceTypeDto;
  @Input() occupations: OccupationDto[] = [];
  @Input() bmiValue: number | null = null;
  @Input() bmiExceedsMax = false;

  readonly Gender = Gender;
}
